import { Outlet } from 'react-router-dom'
import Header from './Header/Header'
import ToastManager from './ToastManager/ToastManager'
import Version from './Version'
import GetQualifiedModal from 'src/modules/OffersManagement/components/GetQualifiedModal'
import VerifyModal from './VerifyModal/VerifyModal'
import KycModal from './KycModal/KycModal'
import GlobalLoader from './GlobalLoader/GlobalLoader'

const MainLayout = () => {
  return (
    <div className='relative min-h-screen pb-10 md:pb-0'>
      <Header className='mb-3 md:mb-8' />
      <ToastManager />
      <Outlet />
      <Version className='fixed bottom-2 left-2' />
      {/* <TermsAndAgreements /> */}
      <GetQualifiedModal />
      <VerifyModal />
      <KycModal />
      <GlobalLoader />
    </div>
  )
}

export default MainLayout
